export const REGION = "eu-west-1"; // Your region
export const IDENTITY_POOL_ID =
  "eu-west-1:9735e824-f04a-4c3c-84ad-ccac69ef5480"; // Your pool ID

const awsconfig = {
  aws_project_region: REGION,
  aws_cognito_identity_pool_id: IDENTITY_POOL_ID,
  aws_cognito_region: REGION,
  Auth: {
    identityPoolId: IDENTITY_POOL_ID,
    region: REGION,
  },
};

export default awsconfig;
